import React from 'react';
import { Table } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

const UrlCell = ({
  rowValues,
  entryRecord,
  index,
  positiveCell,
  negativeCell,
  key,
  t,
  urlPrefix
}) => {
  const value = rowValues[entryRecord.key] !== 'null' ? t(rowValues[entryRecord.key]) : '';
  return (
    <Table.Cell
      key={key}
      className="tableCell tableCellReducedPadding"
      positive={positiveCell}
      negative={negativeCell}
    >
      <a href={urlPrefix + value} target="_blank">
        {value}
      </a>
    </Table.Cell>
  );
};

export default withTranslation()(UrlCell);
